export default __webpack_public_path__ + "static/media/bnr-img.d6de9369.png";